import React from "react";
import { LOADING_SCREEN } from "./assets";
import styles from './LoadingLogo.module.scss';

export default function LoadingLogo() {

    return (
        <div className={styles["background"]}>
            <img src={LOADING_SCREEN.BASE.default} alt="Base" />
            <div className={styles["frame"]}>
                <img src={LOADING_SCREEN.FRAME.default} alt="Frame" />
            </div>
            <div className={styles["logo"]}>
                <img src={LOADING_SCREEN.LOGO.default} alt="Logo" />
            </div>
        </div>
    )
}

